import cn from 'classnames'
import React from 'react'

import styles from './instagram.module.scss'

import Gallery from './gallery'
import Stories from './stories'
import Title from './title'

import DoodleBackground from '../../components/doodle-background'

const isSocialMediaDisabled = true

interface IInstagramProps {
  inverted?: boolean
  variant?: 'brand' | 'free'
}

export default function Instagram({ variant = 'brand', inverted = false }: IInstagramProps) {
  if (isSocialMediaDisabled) {
    return null
  }

  return (
    <div className={cn(styles.root, inverted && styles.inverted)}>
      <Title inverted={inverted} variant={variant} />
      <div className={`${styles.contentArea} row`}>
        <div className="col-xs-12 col-sm-6">
          <Stories variant="free" />
        </div>
        <Gallery className="col-xs-12 col-sm-6" variant="free" />
      </div>
      <DoodleBackground variant="bottomRight" />
    </div>
  )
}

export { Gallery, Stories }
